import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDadosProdutosVendidos(axios, parametros) {  
    parametros.operacao = 'buscarDadosProdutosVendidos';

    let retorno = {}

    await axios.santriGET('/rest/orcamento', parametros, 15, false)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarDadosProdutosVendidos.js